import { spacing } from '@upstox/upstox-ui';

export const preApplyCard: CSSFunction = ({ theme }) => ({
  width: '100%',
  padding: spacing(theme, ['medium']),
});

export const preApplyIcon: CSSFunction = ({ theme }) => ({
  marginRight: spacing(theme, ['medium']),
});

export const preApplyLink: CSSFunction = ({ theme }) => ({
  '& a': {
    textDecoration: 'underline',
  },
});
